import { useEffect, useState } from 'react';

import { listGroups } from '../../../services';

/**
 * Names of every group of the workspace (not the searched subset), loaded while `enabled`, so a
 * form can say a name is taken as it is typed. A failed load leaves the list empty: the service
 * still rejects a duplicate when the group is created.
 *
 * @param {boolean} enabled
 * @returns {string[]}
 */
export const useGroupNames = (enabled) => {
  const [names, setNames] = useState([]);

  useEffect(() => {
    if (!enabled) return undefined;
    let mounted = true;
    listGroups()
      .then((res) => {
        if (mounted) setNames((res?.body?.items ?? []).map((group) => group.name));
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, [enabled]);

  return names;
};
